module.exports = __webpack_public_path__ + "static/img/sprite.3.2.0.8080b678.png";